var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-select",
    {
      attrs: {
        "show-search": "",
        "filter-option": false,
        value: _vm.value,
        disabled: _vm.disabled,
        placeholder: _vm.placeholder,
      },
      on: { change: _vm.handleChange, search: _vm.handleSearch },
    },
    _vm._l(_vm.filteredList, function (item) {
      return _c(
        "a-select-option",
        { key: item.id, attrs: { value: item.id } },
        [_vm._v("\n    " + _vm._s(item.name) + "\n  ")]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }